<template>
  <svg>
    <circle :r="pieChart.getInnerRadius() - 6" cx="100" cy="100" fill="#eee" />

    <text
      :style="{ fontSize: 18, fill: '#494949' }"
      text-anchor="middle"
      x="100"
      y="100"
    >
      <tspan x="100">JML</tspan>
      <tspan :style="{ fontWeight: 600 }" x="100" dy="20px">
        {{ calculateTotal(pieChart) }}
      </tspan>
    </text>
  </svg>
</template>
<script>
const formatNumber = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
}).format;

export default {
  props: {
    pieChart: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    // return this.pieChart.getAllSeries()[0].getVisiblePoints()[0].dataSource;
    // return {
    //   country: this.pieChart.getAllSeries()[0].getVisiblePoints()[0].data
    //     .country,
    // };
  },
  methods: {
    getImagePath(country) {
      return `images/flags/${country.replace(/\s/, "").toLowerCase()}.svg`;
    },

    calculateTotal(pieChart) {
      return formatNumber(
        pieChart
          .getAllSeries()[0]
          .getVisiblePoints()
          .reduce((s, p) => s + p.originalValue, 0)
      );
    },
  },
};
</script>
